import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Componentparameters from '../components/componentparameters'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './palletizing.css'

const Palletizing = (props) => {
  return (
    <div className="palletizing-container">
      <Helmet>
        <title>
          Робот-паллетайзер для упаковки продукции | Линии укладки Arcobo
        </title>
        <meta
          name="description"
          content="Робот-паллетайзер для упаковки мешков, коробок и готовой продукции. Автоматизация паллетирования, интеграция под ключ и запуск в Казахстане и Узбекистане."
        />
        <meta
          property="og:title"
          content="Робот-паллетайзер для упаковки продукции | Линии укладки Arcobo"
        />
        <meta
          property="og:description"
          content="Робот-паллетайзер для упаковки мешков, коробок и готовой продукции. Автоматизация паллетирования, интеграция под ключ и запуск в Казахстане и Узбекистане."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Робот-паллетайзер для упаковки продукции | Линии укладки Arcobo"
        />
        <meta
          name="twitter:description"
          content="Робот-паллетайзер для упаковки мешков, коробок и готовой продукции. Автоматизация паллетирования, интеграция под ключ и запуск в Казахстане и Узбекистане."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/palletizing"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/palletizing"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Palletizing","item":"https://arcobo.tech/palletizing"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name14"></HeaderMain>
      <hr className="palletizing-separator1"></hr>
      <Componenttextimage
        image1Src="/1_Solution/1_1_2_Palletizing/palletizing_12%202-1500w.webp"
        image1Alt="Роботизированная ячейка паллетирования"
        rootClassName="componenttextimageroot-class-name2"
        textComponent={
          <Fragment>
            <span className="palletizing-text100">
              <span className="H1_small">
                Автоматизация укладки, упаковки и подготовки продукции к
                отгрузке
              </span>
              <br></br>
              <span>
                Роботизированные комплексы Arcobo автоматизируют паллетирование,
                упаковку и внутрискладскую логистику готовой продукции. Решение
                позволяет повысить производительность, обеспечить стабильное
                качество укладки и организовать непрерывную работу
                производственной линии.
              </span>
              <br></br>
              <br></br>
              <span className="palletizing-text106 H1_small">
                Преимущества и выгоды:
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text109">✔ </span>
              <span className="palletizing-text110">Работа 24/7</span>
              <br></br>
              <span>
                Комплекс обеспечивает непрерывную паллетизацию продукции без
                снижения производительности и качества укладки.
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text115">✔ </span>
              <span className="palletizing-text116">
                Высокая производительность
              </span>
              <br></br>
              <span>
                Промышленные роботы выполняют тысячи циклов паллетирования за
                смену, сокращая время упаковки и подготовки продукции к
                отгрузке.
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text121">✔ </span>
              <span className="palletizing-text122">
                Стабильное качество укладки
              </span>
              <br></br>
              <span>
                Автоматическая укладка обеспечивает точное расположение
                продукции на паллете, снижая риск повреждений при
                транспортировке.
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text127">✔ </span>
              <span className="palletizing-text128">Быстрая перенастройка</span>
              <br></br>
              <span>
                Система легко адаптируется под различные размеры упаковки, схемы
                паллетирования и типы продукции без сложной переналадки
                оборудования.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Паллетирование и упаковка"
      ></Componenttextimage>
      <hr className="palletizing-separator2"></hr>
      <Component3images
        image1Src="/1_Solution/1_1_2_Palletizing/201_palletizing-200h.webp"
        image1Alt="Паллетирование и упаковка"
        image2Src="/1_Solution/1_1_2_Palletizing/202_palletizing-200h.webp"
        image2Alt="Паллетирование и упаковка"
        image3Src="/1_Solution/1_1_2_Palletizing/203_palletizing-200h.webp"
        image3Alt="Паллетирование и упаковка"
        rootClassName="component3imagesroot-class-name4"
      ></Component3images>
      <hr className="palletizing-separator3"></hr>
      <Componentparameters
        text1={
          <Fragment>
            <span className="palletizing-text131">
              <span className="palletizing-text132">•</span>
              <span> Промышленный робот-паллетайзер</span>
              <br></br>
              <span className="palletizing-text135">•</span>
              <span> </span>
              <span>Захват под продукцию заказчика</span>
              <br></br>
              <span className="palletizing-text139">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Контроллер управления комплексом</span>
              <br></br>
              <span className="palletizing-text143">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Программное обеспечение Arcobo</span>
              <br></br>
              <span className="palletizing-text147">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Защитное ограждение с системой безопасности</span>
              <br></br>
              <span className="palletizing-text151">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Рабочая станция оператора</span>
              <br></br>
              <span className="palletizing-text155">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Пусконаладочные работы</span>
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="palletizing-text158">
              <span>
                Грузоподъемность робота:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text160">до 300 кг</span>
              <br></br>
              <span>
                Максимальный радиус действия:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text163">до 3255 мм</span>
              <br></br>
              <span>
                Производительность:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text166">до 35 циклов/мин*</span>
              <br></br>
              <span>
                Тип продукции:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text169">
                коробки, мешки, канистры, упаковки, лотки, блоки
              </span>
              <br></br>
              <span>
                Схемы паллетирования:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text172">
                неограниченное количество
              </span>
              <br></br>
              <span>
                Работа 24/7:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text175">Да</span>
              <br></br>
              <span>
                Интеграция с конвейерами:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text178">Да</span>
              <br></br>
              <span>
                Онлайн-мониторинг:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text181">Опция</span>
              <br></br>
              <span>
                Удаленная диагностика:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="palletizing-text184">Да</span>
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="palletizing-text185">
              <span className="palletizing-text186">•</span>
              <span> Анализ производственного процесса</span>
              <br></br>
              <span className="palletizing-text189">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Разработка схемы паллетирования</span>
              <br></br>
              <span className="palletizing-text193">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Проектирование роботизированной ячейки</span>
              <br></br>
              <span className="palletizing-text197">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Изготовление захватного устройства</span>
              <br></br>
              <span className="palletizing-text201">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Пусконаладочные работы</span>
              <br></br>
              <span className="palletizing-text205">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Обучение операторов и технического персонала</span>
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="palletizing-text208">
              <span className="palletizing-text209">•</span>
              <span> Автоматический магазин паллет</span>
              <br></br>
              <span className="palletizing-text212">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Подача межслойных прокладок</span>
              <br></br>
              <span className="palletizing-text216">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Машинное зрение</span>
              <br></br>
              <span className="palletizing-text220">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Автоматическая упаковка в стрейч-пленку</span>
              <br></br>
              <span className="palletizing-text224">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Этикетирование продукции</span>
              <br></br>
              <span className="palletizing-text228">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Интеграция с ERP и MES</span>
              <br></br>
              <span className="palletizing-text232">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система контроля качества продукции</span>
              <br></br>
              <span className="palletizing-text236">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Индивидуальные захваты под продукцию заказчика</span>
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="palletizing-text239">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        heading1="A. Базовая комплектация"
        heading2="B. Базовые характеристики"
        heading3="C. В состав поставки включены:"
        heading4="D. Дополнительные опции"
        showDiv1
        showDiv5={false}
        mainHeading="Характеристики базовой ячейки "
        rootClassName="componentparametersroot-class-name2"
        componentTitle="Паллетирование и упаковка"
      ></Componentparameters>
      <Component3images
        image1Src="/1_Solution/1_1_2_Palletizing/204_palletizing-200h.webp"
        image1Alt="Роботизированный паллетайзер"
        image2Src="/1_Solution/1_1_2_Palletizing/205_palletizing-200h.webp"
        image2Alt="Роботизированный паллетайзер"
        image3Src="/1_Solution/1_1_2_Palletizing/206_palletizing-200h.webp"
        image3Alt="Роботизированный паллетайзер"
        rootClassName="component3imagesroot-class-name5"
      ></Component3images>
      <hr className="palletizing-separator4"></hr>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="palletizing-text240">
              Комплекс подходит для паллетирования коробок, мешков, канистр,
              бутылок, лотков, строительных материалов, упаковок с пищевой
              продукцией и других изделий. Захватное устройство разрабатывается
              индивидуально под характеристики продукции.
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="palletizing-text241">
              Автоматизация наиболее выгодна при высокой интенсивности
              производства, многосменной работе, тяжелых грузах и дефиците
              персонала. Робот обеспечивает стабильную производительность
              независимо от времени суток и нагрузки.
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="palletizing-text242">
              <span>
                Да.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                Комплекс поддерживает хранение нескольких программ
                паллетирования и быстро переключается между различными форматами
                упаковки и схемами укладки.
              </span>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="palletizing-text246">
              <span>
                Да.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                Роботизированные комплексы Arcobo интегрируются с действующими
                конвейерами, упаковочными машинами, системами маркировки и
                складской логистикой без необходимости полной модернизации
                производства.
              </span>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="palletizing-text252">
              <span>
                Автоматизация позволяет снизить физическую нагрузку на персонал,
                устранить влияние человеческого фактора, повысить
                производительность упаковочного участка и обеспечить стабильную
                работу производства в режиме 24/7.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="palletizing-text255">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="palletizing-text256">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="palletizing-text257">answer</span>
          </Fragment>
        }
        showDiv5
        showDiv6
        showDiv7
        question1="Какие виды продукции можно паллетировать?"
        question2="Когда роботизированная паллетизация наиболее эффективна?"
        question3="Можно ли работать с несколькими типами продукции?"
        question4="Можно ли интегрировать робот в существующую линию?"
        question5="Какой экономический эффект дает роботизированная паллетизация?"
        rootClassName="componentfaqroot-class-name2"
      ></Componentfaq>
      <hr className="palletizing-separator5"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name14"></FooterMain>
    </div>
  )
}

export default Palletizing
